import 'bootstrap/dist/css/bootstrap.min.css';

import './App.css';

import MiApi from './components/MiApi';

function App()
{
    return (
        <div className="App bg-light">
            <MiApi></MiApi>
        </div>
    );
}

export default App;
